module.exports = __webpack_public_path__ + "img/vid_6_splash.1b137be0.jpg";